import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { successMessage } from '../constants';
import { AllTappedQtyDialogComponent } from './all-tapped-qty/all-tapped-qty-dialog.component';
import { ContainerTapService } from '../services/container-tap/container-tap.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-all-tapped-qty-cell-renderer',
  template: `
  <a *ngIf="isClickable" href="#" (click)="openDialog($event)">
  {{ params.value }}
  </a>
  <span *ngIf="!isClickable">
  {{ params.value }}
  </span>

  `
})
export class AllTappedQtyCellRendererComponent implements ICellRendererAngularComp {
  params: any;
  namcValue = localStorage.getItem('namcvalue');
  userName = localStorage.getItem('UserName');
  userRole = localStorage.getItem('UserRoles');
  user = localStorage.getItem('workdayId');
  timezone = localStorage.getItem('timezone');
  displayText;

  constructor( 
    private readonly dialog: MatDialog,
    private readonly containerTapService: ContainerTapService,
    private readonly spinner: NgxSpinnerService
  ) {}

  isClickable = false;

  // agInit(params: any): void {
  //   this.params = params;
  //   const data = params.data;
  
  //   // Extract all keys that match 'kanban_status_####'
  //   const statusKeys = Object.keys(data).filter(
  //     key => key.startsWith('kanban_status_') && /^\d{4}$/.test(key.slice(14))
  //   );
  
  //   // Check if any kanban_status is not "FULLY TAP" AND its corresponding kanban_#### is not null
  //   this.isClickable = statusKeys.some(statusKey => {
  //     const kbCode = statusKey.slice(14); // Extract ####
  //     const kbValue = data[`kanban_${kbCode}`];
  //     const statusValue = data[statusKey];
  
  //     return kbValue != null && statusValue !== 'FULLY TAPPED';
  //   });
  // }
  agInit(params: any): void {
    this.params = params;
    const data = params.data;
  
    const canTapCount = data.can_tap_kb_count;
    console.log(canTapCount,'canTapCount')

    if (canTapCount === '0') {
      this.isClickable = false;
      this.displayText = ''; //  prevents "0" showing
      return;
    }
  
    //  Proceed to check for clickable condition based on kanban_status_####
    const statusKeys = Object.keys(data).filter(
      key => key.startsWith('kanban_status_') && /^\d{4}$/.test(key.slice(14))
    );
  
    this.isClickable = statusKeys.some(statusKey => {
      const kbCode = statusKey.slice(14); // Extract ####
      const kbValue = data[`kanban_${kbCode}`];
      const statusValue = data[statusKey];
  
      return kbValue != null && statusValue !== 'FULLY TAPPED';
    });
  
    // Optional: Set displayText if needed (based on data or isClickable)
    this.displayText = this.isClickable ? canTapCount : '';
  }
  
  refresh(): boolean {
    return false;
  }
  openDialog(event: MouseEvent): void {
    event.preventDefault();
    const kanbanData = this.params.data;
    const dynamicValue: string[] = Object.keys(kanbanData)
  .filter(key => key.startsWith('kanban_') && /^\d{4}$/.test(key.slice(7))) // only kanban_####
  .map(key => {
    const kbCode = key.slice(7); // e.g. '0002'
    const kbValue = kanbanData[key];
    const status = kanbanData[`kanban_status_${kbCode}`];
    return (kbValue != null && status !== 'FULLY TAP' && status !== 'FULLY TAPPED') ? kbCode : null;
  })
  .filter((kbCode): kbCode is string => kbCode !== null);
  
    const dialogRef = this.dialog.open(AllTappedQtyDialogComponent, {
      width: '650px',
      maxHeight: '450px',
      data: {
        dockList: localStorage.getItem('dock'),
        business_entity: kanbanData.business_entity,
        container_renban: kanbanData.container_renban,
        module_number: kanbanData.module_number,
        planned_stocking_datetime: kanbanData.planned_stocking_datetime,
        kanban: dynamicValue,
        mode: 'All',
      }
    });
  
    const addGetResponse = dialogRef.componentInstance?.editTapedQtyEventEmitter?.subscribe({
      next: (res) => {
        const data1 = {
          business_entity: this.namcValue,
          workid: this.user,
          user_role: this.userRole,
          userid: this.userName,
          Tap:res.scheduleData,// if save false else true
          stocked_date: res.stockingDate,
          stocked_datetime: res.stockingDate + ' ' + res.stockingTime,
          data: [
            {
              userid: this.userName,
              dock: res.dock,
              kanban: res.kanban,
              container_renban: res.container,
              module_number: res.moduleNumber,
            }
          ]
        };
  
        this.containerTapService?.tapMultipleparts(data1)?.subscribe({
          next: (response) => {
            const inserted = response.body?.insertedRows ?? 0;
            const updated = response.body?.updatedRows ?? 0;
            const scheduleTap = response.body?.updatedRowsTap ?? 0;
  
            const parent = this.params.context.componentParent;
  
            if ((inserted >= 1 && updated >= 1) || (updated >= 1 && scheduleTap >= 1)) {
              parent.selectedContainerFrom.container_renban = res.container;
              parent.selectedContainerTo.container_renban = res.container;
              // parent.selectedModule = res.moduleNumber;
              parent.onSearch(0);
              parent.selectedContainerFrom = [];
              parent.selectedContainerTo = [];
              parent.selectedModule = '';
            } else {
              parent.onSearch(0);
            }
  
            parent.successMessage =
              ((inserted >= 1 && updated >= 1) || (updated >= 1 && scheduleTap >= 1))
                ? successMessage.tapUpdated
                : successMessage.scheduleUpdated;
  
            window.scroll(0, 0);
          }
        });
      }
    });
  
    dialogRef.afterClosed().subscribe(() => {
      addGetResponse?.unsubscribe();
    });
  }
}
